import { z } from 'zod'

export const protocolReviewStepDataSchema = z.object({
  acknowledged: z.literal(true),
  acknowledged_at: z.string().min(1),
})
